import React from 'react';
import { UserAgreementModal } from './UserAgreementModal';
import { FAQS_VERSION, FAQS_TEXT } from '../config/faqs';

interface FaqsModalProps {
  visible: boolean;
  onClose: () => void;
}

export const FaqsModal: React.FC<FaqsModalProps> = ({ visible, onClose }) => (
  <UserAgreementModal
    visible={visible}
    onClose={onClose}
    title="Help & FAQs"
    version={FAQS_VERSION}
    text={FAQS_TEXT}
  />
);
